export const APP_URL = 'https://my.effzone.com';
export const SIGNUP_URL = 'https://my.effzone.com/start';
export const LOGIN_URL = 'https://my.effzone.com/login';
export const CONTACT_EMAIL = 'mailto:hi@rieshim.app';
